import React from 'react';
import { connect } from 'react-redux';
import Box from '../Layout/Box';
import ButtonStrip from '../Layout/ButtonStrip';
import BoxButton from '../Layout/BoxButton';
import ModalSelectorFromList from '../Shared/ModalSelectorFromList';
import ModalFilter from './ModalFilter';
import { changeNumberRegisterToShow, downloadFile, getReporteRadicados, setOrderBy, showHideModalFilter, updateInputs } from '../../actions/reportes';
import { showModalSelector, selectFromSelector, getParameterByName } from '../../actions/common';


class ReporteTiquetes extends React.Component {

    downloadFile(type_report) {
        const url = '/reportes/download_reporte_documentos_tiquetes';
        const params = {
            fecha_inicio: this.props.reportes.getIn(['document_reporter_tickets', 'initial_date']),
            fecha_fin: this.props.reportes.getIn(['document_reporter_tickets', 'final_date']),
            type_report
        };
        return this.props.downloadFile(url, params, type_report);
    }

    render() {

        const { reportes } = this.props;     

        const boxActions = [
            <BoxButton key="ba[0][2]" name="file-excel-o" onClick={ e => this.downloadFile('xlsx') } title="Descargar excel"/>
        ];

        const formRequest = <div className="row" style={{padding:'0px'}}>
            <div className="col-md-2 col-sm-4 col-xs-12">
                <div className="form-group">
                    <label htmlFor="initial_date" className="control-label">Fecha Inicial</label>
                    <input type="date" className="form-control input-sm" name="initial_date"
                        value={reportes.getIn(['document_reporter_tickets', 'initial_date'])}
                        onChange={(e) => this.props.updateInputs("document_reporter_tickets.initial_date", e.target.value)} />
                </div>
            </div>
            <div className="col-md-2 col-sm-4 col-xs-12">
                <div className="form-group">
                    <label htmlFor="final_date" className="control-label">Fecha Final</label>
                    <input type="date" className="form-control input-sm" name="final_date"
                        value={reportes.getIn(['document_reporter_tickets', 'final_date'])}
                        onChange={(e) => this.props.updateInputs("document_reporter_tickets.final_date", e.target.value)} />
                </div>
            </div>
        </div>



        return (
            <div className="row" style={{ height: '100%' }}>
                <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: '100%' }}>
                    <Box title="Reporte de tiquetes" stretch>
                        <ButtonStrip actions={boxActions} formRequest = { formRequest } />
                    </Box>
                </div>
                <ModalSelectorFromList />
                <ModalFilter />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { reportes } = state;
    return {
        reportes,
    }
};



const mapDispatchToProps = (dispatch) => {
    return {
        //getProviders: (keyword, cb) => dispatch(getProviders(keyword, cb))
        showModalSelector: (title, fields, url, action) => dispatch(showModalSelector(title, fields, url, action)),
        showHideModalFilter: (state, tableCols) => dispatch(showHideModalFilter(state, tableCols, 'document_reporter_tickets')),
        setOrderBy: (field) => dispatch(setOrderBy(field, 'document_reporter_tickets')),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        changeNumberRecordsToShow: (number) => dispatch(changeNumberRegisterToShow(number, 'document_reporter_tickets')),
        search: (page = 1) => dispatch(getReporteRadicados(page)),
        downloadFile: (url, params, type) => dispatch(downloadFile(url, params, `document_reporter_tickets.${type}`)),
        getParameterByName: (nombre) => dispatch(getParameterByName(nombre)),
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReporteTiquetes);


// WEBPACK FOOTER //
// ./src/components/Reportes/ReporteTiquetes.jsx